export default __webpack_public_path__ + "static/media/whatsapp.8cbc096f.svg";